import { HttpParams } from '@angular/common/http';
import dayjs from 'dayjs';
import { FetchArgs } from 'src/app/shared/models/core';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

export function buildHttpParams(params: any, data: any, currentPath: string) {
    Object.keys(data).forEach((key) => {
        if (data[key] instanceof Array) {
            params[`${currentPath}${key}`] = data[key];
        } else if (data[key] instanceof Date) {
            params[`${currentPath}${key}`] = dayjs(data[key]).format('MM-DD-YYYY');
        } else if (data[key] instanceof Object) {
            buildHttpParams(params, data[key], `${currentPath}${key}.`);
        } else if (typeof data[key] === 'number' && Number(data[key]) >= 0) {
            params[`${currentPath}${key}`] = data[key];
        } else if (data[key]) {
            params[`${currentPath}${key}`] = data[key];
        }
    });
}

export function interpolateParams(params: object = {}): HttpParams {
    if (params instanceof HttpParams) {
        return params;
    }

    function formatValue(val) {
        switch (true) {
            case typeof val === 'number':
            case typeof val === 'string': {
                return String(val);
            }
            case val instanceof Date: {
                return dayjs(val).format('MM/DD/YYYY');
            }
            default:
                return JSON.stringify(val);
        }
    }

    return Object.keys(params)
        .filter((key) => !isEmpty(params[key]))
        .reduce((p, key) => {
            const val = params[key];
            if (Array.isArray(val)) {
                return val.filter((k) => !isEmpty(k)).reduce((_p, value) => _p.append(key, formatValue(value)), p);
            }

            return p.set(key, formatValue(val));
        }, new HttpParams());
}

export function fixDateFilters(args: FetchArgs) {
    if (!args?.filter) {
        return;
    }
    for (const field in args.filter) {
        if (Object.prototype.toString.call(args.filter[field]) === '[object Date]') {
            args.filter[field] = args.filter[field].toLocaleString('sv');
        }
    }
}
